import React, { useEffect, useRef, useState } from "react";
import {
  AttachmentField,
  Button,
  Divider,
  FormFieldSet,
  Modal,
  PageHeader,
  PageTitle,
  useFormHandler,
  AttachmentSection,
} from "../../../../../../components";
import { v4 as uuidv4 } from "uuid";
import {
  documentType,
  status,
} from "../../../../../../assets/data/projectData";
import { useAttachmentHandlers } from "../../../../../../hooks/useAttachmentHandlers";
import useDropdownData from "../../../../../../hooks/useDropdownData";
import { filterEmptyValues } from "../../../../../../utils/filterEmptyValues";
import { getAllDocumentsStart } from "../../../../../../redux/slices/document/documentSlice";
import { useDispatch, useSelector } from "react-redux";
import { uploadStart } from "../../../../../../redux/slices/universal/fileUploadSlice";
import { addDocumentStart } from "../../../../../../redux/slices/universal/documentsSlice";
import { useLoginUser } from "../../../../../../hooks/useLoginUser";

const DocumentModal = ({ isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { userData: loginUserData } = useLoginUser();
  const loginUserUiid = loginUserData?.uiid;
  const { employeeProfileUiid } = useSelector((state) => state.employee);
  const [validationRules, setValidationRules] = useState({});
  const containerRef = useRef(null);
  const initialFormData = {
    documentType: "",
    title: "",
    status: "",
    expiryDates: "",
    comments: "",

    attachments: [
      {
        id: uuidv4(),
        // attachmentName: "",
        // attachmentComments: "",
        chooseFiles: [],
      },
    ],
  };

  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, validationRules);

  useEffect(() => {
    const baseRules = {
      documentType: { type: "select", required: true },
      status: { type: "select", required: true },
      attachments: [
        {
          // attachmentName: { type: "text", required: true },
          // attachmentComments: { type: "text", required: true },
          chooseFiles: {
            type: "file",
            required: true,
            // allowedFiles: [
            //   { ext: "png", mime: "image/png" },
            //   { ext: "txt", mime: "text/plain" },
            // ],
          },
        },
      ],
    };
    setValidationRules(baseRules);
  }, [formData.documentType, formData.attachments.length]);

  const handleSave = () => {
    const isValid = validateAllFields();
    if (isValid) {
      const document = {
        docType: formData?.documentType,
        docExpiry: formData?.expiryDates,
        comments: formData?.comments,
        title: formData?.title,
        docStatus: formData?.status ? 1 : "",
      };
      const submissionData = filterEmptyValues(document);
      const cleanAttachments = formData.attachments.filter(
        (att) =>
          att.attachmentName.trim() !== "" ||
          att.attachmentComments.trim() !== "" ||
          (att.chooseFiles && att.chooseFiles.length > 0),
      );
      if (cleanAttachments?.length) {
        dispatch(
          uploadStart({
            uploadType: "multiple",
            field: "doc",
            uiid: employeeProfileUiid,
            entity: "documents",
            category: "documents",
            coll: "Document", //WorkAuth
            doc: cleanAttachments.flatMap((doc) =>
              doc.chooseFiles.map((file) => {
                file.id = doc.id;
                return file;
              }),
            ),
            onSuccess: async (fileData) => {
              dispatch(
                addDocumentStart({
                  coll: "Document",
                  refId: employeeProfileUiid,
                  refField: "additionalDocs",
                  refColl: "Employee",
                  payload: {
                    addedBy: loginUserUiid,
                    ...submissionData,
                    attachments: [
                      {
                        parent: { employee: employeeProfileUiid },
                        addedBy: loginUserUiid,
                        ...submissionData,
                        ref: {
                          id: employeeProfileUiid,
                          entity: "additionalDocs", // collection name this doc belongs to
                          path: `additionalDocs`,
                        },
                        file: cleanAttachments.map((obj) => ({
                          name: obj.attachmentName,
                          comments: obj.attachmentComments,
                          keys: fileData
                            .filter(
                              (file) => file?.fileRefId === obj.id && file.key,
                            ) // match and ensure key exists
                            .map((file) => file.key),
                        })),
                      },
                    ],
                  },
                  //onSuccess: handleModalClose,
                  onSuccess: async () => {
                    const filter = {
                      "parent.employee": {
                        type: "NONE",
                        value: employeeProfileUiid,
                      },
                      docType: {
                        type: "EXCLUDE",
                        value: [
                          "Passport",
                          "I94",
                          "Everify",
                          "certified LCA",
                          "online Paper",
                          "Visa",
                        ],
                      },
                    };
                    dispatch(
                      getAllDocumentsStart({
                        cache: false,
                        uiid: employeeProfileUiid,
                        tab: "documentsTab",
                        ret: "document",
                        type: "ref.id",
                        coll: "Document",
                        filter,
                      }),
                    );
                    onClose();
                  },
                }),
              );
            },
          }),
        );
      }
    } else {
      console.log("Form error :", errors);
    }
  };

  ///////////////////////////////////////////////////
  //handel Attachment Error
  ///////////////////////////////////////////////////

  const getAttachmentError = (index, field) => {
    return errors?.attachments?.[index]?.[field] || "";
  };
  ///////////////////////////////////////////////////
  //handel Attachment Error end
  ///////////////////////////////////////////////////

  ///////////////////////////////////////////////////
  ///// Get select data form server
  ///////////////////////////////////////////////////
  const {
    data: documentTypesOptions,
    searchValue: documentTypesSearch,
    handleSearch: handleDocumentTypesSearch,
    resetSearch: resetDocumentTypesSearch,
    handleScroll: handleDocumentTypesScroll,
  } = useDropdownData("documentTypes");
  ///////////////////////////////////////////////////
  ///// Get select data form server end
  ///////////////////////////////////////////////////
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="ADD DOCUMENTS"
      width="max-w-7xl"
    >
      <div className="overflow-auto">
        <div className="grid grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-4 px-2 max-w-7xl">
          {/* <FormFieldSet
            type="select"
            title="Document Type"
            placeholder="Select Document Type"
            value={formData.documentType}
            onChange={(value) => handleChange("documentType", value)}
            error={errors.documentType}
            showButton
            alertName={"addDocumentType"}
            showSearch
            options={documentType}
          /> */}

          <FormFieldSet
            type="select"
            title="Document Type"
            placeholder="Select Document Type"
            keyname={"documentTypes"}
            options={documentTypesOptions}
            value={formData.documentType}
            onChange={(value) => handleChange("documentType", value)}
            error={errors.documentType}
            showSearch
            searchValue={documentTypesSearch}
            onSearch={handleDocumentTypesSearch}
            onClose={resetDocumentTypesSearch}
            showButton
            alertName={"addDocumentType"}
            icon={"add"}
            handleScroll={() => handleDocumentTypesScroll(containerRef)}
            refData={containerRef}
            required
          />

          <FormFieldSet
            type="text"
            title="Title"
            placeholder="Enter Title"
            value={formData.title}
            onChange={(value) => handleChange("title", value)}
            error={errors.title}
          />
          <FormFieldSet
            type="select"
            title="Status"
            placeholder="Select Status"
            value={formData.status}
            onChange={(value) => handleChange("status", value)}
            error={errors.status}
            options={status}
          />
          <FormFieldSet
            type="datepicker"
            title="Expiry Dates"
            placeholder="Select Expiry Dates"
            value={formData.expiryDates}
            onChange={(value) => handleChange("expiryDates", value)}
            error={errors.expiryDates}
            showDropdown={false}
          />
          <FormFieldSet
            type="textArea"
            title="Comments"
            placeholder="Enter Comments"
            value={formData.comments}
            onChange={(value) => handleChange("comments", value)}
            error={errors.comments}
          />
        </div>
        <div className="mt-4 mb-1">
          <PageHeader
            Section={
              <div className="flex">
                <PageTitle title="Attachments" tag="h6" />
              </div>
            }
          />
        </div>
        <Divider />
        <AttachmentSection
          attachments={formData.attachments}
          onChange={(newAttachments) =>
            setFormData({ ...formData, attachments: newAttachments })
          }
          getAttachmentError={getAttachmentError}
          showNameField={true}
          showCommentsField={true}
        />
        <div className="flex gap-3 justify-end my-6">
          <Button title="Cancel" variant="outlined" onClick={onClose} />
          <Button title="Save" onClick={() => handleSave()} />
        </div>
      </div>
    </Modal>
  );
};

export default DocumentModal;
